import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import storefront from "../helpers/storefront";
import * as queries from "../helpers/storefront/queries";
import BlogNav from "./blog-nav";
import BlogCard from "./blog-card";
import BlogCardWide from "./blog-card-wide";
import useBlogCardHeights from "../helpers/useBlogCardHeights";

export default function Blog({ data }) {
  const [cachedArticles, setCachedArticles] = useState([]);
  const [articles, setArticles] = useState([]);
  const [reverse, setReverse] = useState(false);
  const [cursor, setCursor] = useState(null);
  const [endCursor, setEndCursor] = useState(null);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [tag, setTag] = useState(null);
  const [trackHeight, cardContentHeight] = useBlogCardHeights();

  useEffect(() => {
    // Grab tag, if any, from URL to allow deep linking
    const url = new URL(window.location);
    const sortBy = url.searchParams.get("sort_by");
    if (sortBy === "oldest") {
      setReverse(true);
    }

    const result = /\/tagged\/(?<tagHandle>.+)$/.exec(url.pathname);

    if (!result) return;

    const { tagHandle } = result.groups;

    const matchingTag = data.filterTags.find(
      (value) => window.handleize(value) === tagHandle
    );

    if (matchingTag) {
      setTag(matchingTag);
    }
  }, []);

  useEffect(() => {
    setCursor(null);
    setEndCursor(null);
    setHasNextPage(false);
  }, [tag, reverse]);

  useEffect(() => {
    storefront
      .request({
        query: queries.getArticles,
        variables: {
          blogHandle: data.blogHandle,
          first: data.posts_per_page,
          sortKey: "PUBLISHED_AT",
          reverse: !reverse,
          after: cursor,
          query: tag ? `tag:${tag}` : null,
        },
      })
      .then(({ data }) => {
        setArticles([
          ...cachedArticles,
          ...data.blog.articles.edges
            .map((edge) => edge.node)
            .filter((node) => !node.hideFromListing?.value),
        ]);
        setEndCursor(data.blog.articles.pageInfo.endCursor);
        setHasNextPage(data.blog.articles.pageInfo.hasNextPage);
        setCachedArticles([]);
      });
  }, [cursor, tag, reverse]);

  const loadMore = () => {
    if (!hasNextPage) return;
    setCachedArticles(articles);
    setCursor(endCursor);
  };

  return (
    <>
      <BlogNav
        blogUrl={data.blogUrl}
        tags={data.filterTags}
        tag={tag}
        setTag={setTag}
        reverse={reverse}
        setReverse={setReverse}
      />
      <div className="main-blog__articles">
        {articles.map((article, i) => {
          if (i === 0 && data.first_post_style === "wide") {
            return <BlogCardWide article={article} key={article.handle} />;
          }

          return (
            <BlogCard
              article={article}
              trackHeight={(height) => trackHeight({ id: article.id, height })}
              minHeight={cardContentHeight}
              key={article.handle}
            />
          );
        })}
      </div>
      {hasNextPage && (
        <div className="main-blog__load-more-wrapper">
          <button
            className="button button--outline-secondary"
            onClick={loadMore}
          >
            Load more
          </button>
        </div>
      )}
    </>
  );
}
